<div style="position: relative" [style.width]="!width ? null : width" [style.height]="!height ? null : height">
  <canvas [attr.width]="!width ? null : width" [attr.height]="!height ? null : height"></canvas>
</div>
